import {inject, Injectable} from "@angular/core";
import {AUX_ID_PREFIX} from "@core/consts/map.constants";
import {v4 as uuidv4} from 'uuid';
import {DatacenterV2} from "@core/model/datacenter-v2";
import {Observable} from "rxjs";
import {environment} from "@environment/environment";
import {HttpClient} from "@angular/common/http";
import {RoleModel} from "@core/model/aux/role.model";
import {PermissionModel} from "@core/model/aux/permission.model";
import {AppUserModel} from "@core/model/aux/app-user.model";

@Injectable({providedIn: 'root'})
export class UsersService {
  http: HttpClient = inject(HttpClient);

  constructor() {

  }

  public buildPermissionsConfig(allPermissions: PermissionModel[], selectedPermissions: PermissionModel[]) {
    return {
      sourcePermissions: allPermissions.filter(p => selectedPermissions.map(sp => sp._id).indexOf(p._id) == -1),
      selectedPermissions
    };
  }


  //API calls
  public getUserRoles(params: any): Observable<any> {
    return this.http.get(`${environment.apiUsersUrl}/roles`, {
      responseType: 'json',
      params
    });
  }

  public getUsers(): Observable<any> {
    return this.http.get(`${environment.apiUsersUrl}/users`);
  }

  public getRoleDetails(role: RoleModel): Observable<any> {
    return this.http.get(`${environment.apiUsersUrl}/roles/${role._id}`, {
      responseType: 'json'
    });
  }

  public getPermissions(params: any): Observable<any> {
    return this.http.get(`${environment.apiUsersUrl}/permissions`, {
      responseType: 'json',
      params
    });
  }

  public saveRole(role: RoleModel): Observable<any> {
    return this.http.post(`${environment.apiUsersUrl}/roles`, role);
  }

  public updateRole(role: RoleModel): Observable<any> {
    return this.http.put(`${environment.apiUsersUrl}/roles/${role._id}`, {
      name: role.name,
      description: role.description,
      permissions: role.permissions?.map(p => p._id),
    });
  }

  public deleteRole(role: RoleModel): Observable<any> {
    return this.http.delete(`${environment.apiUsersUrl}/roles/${role._id}`);
  }

  public assignRoleToUser(user: AppUserModel): Observable<any> {
    const dto = {
      ...user,
      roles: [user.roles[0]._id]
    }
    return this.http.put(`${environment.apiUsersUrl}/users`, {users: dto});
  }
}
